/**
 * ChangeFlags — compact colored indicator dots for detected changes.
 * Data comes directly from backlink columns populated by the crawler.
 */
export default function ChangeFlags({ backlink }) {
  if (!backlink) return null;

  const flags = [];

  // Orange dot: anchor text changed
  if (
    backlink.previous_anchor_text &&
    backlink.anchor_text_found &&
    backlink.previous_anchor_text !== backlink.anchor_text_found
  ) {
    flags.push({
      color: 'bg-orange-400',
      title: `Anchor changed: "${backlink.previous_anchor_text}" → "${backlink.anchor_text_found}"`,
    });
  }

  // Blue dot: link type changed
  if (
    backlink.previous_link_type &&
    backlink.link_type &&
    backlink.previous_link_type !== backlink.link_type
  ) {
    flags.push({
      color: 'bg-blue-400',
      title: `Link type changed: ${backlink.previous_link_type} → ${backlink.link_type}`,
    });
  }

  // Red dot: page noindexed
  if (
    backlink.meta_robots &&
    backlink.meta_robots.toLowerCase().includes('noindex')
  ) {
    flags.push({
      color: 'bg-red-400',
      title: `Page is noindexed (meta robots: ${backlink.meta_robots})`,
    });
  }

  // Yellow dot: target URL changed
  if (
    backlink.target_url_found &&
    backlink.target_url &&
    backlink.target_url_found !== backlink.target_url
  ) {
    flags.push({
      color: 'bg-yellow-400',
      title: `Target URL changed: expected ${backlink.target_url}, found ${backlink.target_url_found}`,
    });
  }

  if (flags.length === 0) return null;

  return (
    <span className="inline-flex items-center gap-1 ml-1.5">
      {flags.map((flag, i) => (
        <span
          key={i}
          className={`inline-block w-2 h-2 rounded-full ${flag.color} flex-shrink-0`}
          title={flag.title}
        />
      ))}
    </span>
  );
}
